import { render, staticRenderFns } from "./LeadFlowNewLeadsSocket.vue?vue&type=template&id=023d7a4b&"
import script from "./LeadFlowNewLeadsSocket.vue?vue&type=script&lang=js&"
export * from "./LeadFlowNewLeadsSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports